import './SelfieCarousel.scss';

export const SelfieCarousel = ({ reports, onClick, selectedAnalysisId }) => {
  return (
    <div className="selfie-carousel">
      {reports?.map((report, index) => (
        <SelfieCard key={index} report={report} onClick={onClick} selectedAnalysisId={selectedAnalysisId} />
      ))}
    </div>
  );
};

const SelfieCard = ({ report, onClick, selectedAnalysisId }) => {
  return (
    <img
      src={report?.imageUrls?.skinHealth}
      alt="SelfieIcon"
      className={`selfie ${report.analysisId === selectedAnalysisId ? 'selected' : ''}`}
      onClick={() => onClick(report.analysisId)}
    />
  );
};
